export const STORAGE_KEY = 'genai_chat_history';
export const TTL_HOURS = 24;

export const SAMPLE_PROMPTS = [
  'What services does Bureau offer?',
  "How can I integrate Bureau's API?",
  "Tell me about Bureau's fraud detection capabilities",
  'How bureau can help me setup a bank account verification flow?',
];
